export default "__VITE_ASSET__1cc49f99__"